import React, { useState } from "react";
import axios from "axios";
import "../Login/login.css";

function Login({ onLogin }) {
    const [input, setInput] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleLogin = async () => {
        try {
            const res = await axios.post("https://sms.jaigurujewellers.com/api/v1/auth/login", {
                input,
                password,
            });

            console.log(res.data);

            onLogin(res.data.data); // pass user data to App
        } catch (err) {
            setError(err.response?.data?.message || "Login failed");
        }
    };

    return (
        <div className="login-wrapper">

            <div className="card login-card">
                <h2 className="title">Login</h2>

                <div className="form-group">
                    <label>Username / Mobile</label>
                    <input
                        type="text"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        placeholder="Enter username or mobile"
                    />
                </div>

                <div className="form-group">
                    <label>Password</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Enter password"
                    />
                </div>

                {error && <p className="error">{error}</p>}

                <div className="button-group">
                    <button className="button save" onClick={handleLogin}>
                        Login
                    </button>

                    <button
                        className="button clear"
                        onClick={() => {
                            setInput("");
                            setPassword("");
                            setError("");
                        }}
                    >
                        Clear
                    </button>
                </div>

            </div>

        </div>
    );
}

export default Login;